export const appName = "Battle Calculator";
export const appDescription = "Tabletop battle simulation";
